1
<template>
  <div class="receipt-list">

    <div class="big-list">
      <table v-if="receiptsList && receiptsList.list.length > 0" class="table table-striped">
        <thead>
          <tr class="font-weight-bold small">
            <th style="width: 90px;" class="text-center" scope="col">#</th>
            <th style="width: 90px;" class="text-center">_rk#</th>
            <th scope="col">{{ $t('#TR-date') }}</th>
            <th scope="col">{{ $t('#TR-restaurant') }}</th>
            <th scope="col">{{ $t('#TR-cash-group') }}</th>
            <th></th>
          </tr>
        </thead>

        <tbody is="transition-group"
               name="fade2"
               mode="out-in">
          <tr v-for="receipt in receiptsList.list" :key="receipt.id">
            <td class="text-secondary font-weight-bolder text-right">
              {{ receipt['receiptNum'] }}
            </td>
            <td class="text-secondary font-weight-bolder text-right">
              {{ receipt['rkReceiptNum'] }}
            </td>
            <td>{{ receipt['closeDateTime'] | moment('DD.MM.YYYY') }}</td>
            <td>{{ receipt['restaurantName'] }}</td>
            <td>{{ receipt['cashGroupName'] }}</td>
            <td class="receipt-btn receipt"
                @click="onShowPreview(receipt)">
              <span class="mdi mdi-receipt"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div is="transition-group"
         v-if="receiptsList && receiptsList.list.length > 0"
         name="fade2"
         class="small-list">
      <div v-for="(receipt, idx) of receiptsList.list"
           :key="receipt.id"
           class="item shadow-sm  border border-grey-200">
        <div class="clearfix">
          <span class="text-info font-weight-bold float-left">{{ receipt['receiptNum'] }}</span>
          <span class="small text-dark font-weight-bold mr-5 float-right">{{ receipt['closeDateTime'] | moment('DD.MM.YYYY') }}</span>
        </div>

        <div class="text-dark ">{{ receipt['restaurantName'] }}</div>
        <div class="small font-weight-bold text-muted">{{ receipt['cashGroupName'] }}</div>
        <div class="action-selector-btn bg-secondary"
             @click="onShowPreview(receipt)">
          <span class="mdi mdi-receipt"></span>
        </div>
      </div>
    </div>

    <div v-if="receiptsList && receiptsList['totalCount'] === 0" class="row">
      <div class="col-12 text-center text-muted">
        {{ $t('#TR-no-documents-found') }}
      </div>
    </div>

    <div v-if="!receiptsList" class="row">
      <div class="col-12 text-center text-muted">
        {{ $t('#TR-document-search') }}
      </div>
    </div>

  </div>
</template>

<script lang="js">
  import { mixin as clickout } from 'vue-clickout';

  export default {
    mixins: [clickout],
    props: {
      receiptsList: {
        type: Object,
        default: function () {
          return {};
        }
      }
    },

    data() {
      return {
        smallList: true
      };
    },
    methods: {
      onShowPreview(receipt) {
        this.$emit('on-show-preview', receipt);
      }
    }
  };
</script>

<style lang="stylus">

.big-list {
  display: block;
}

.receipt-btn {
  width: 40px;
  padding: 0 !important;
  cursor: pointer;

  .mdi {
    font-size: 30px;
    line-height: 44px;
    display: block;
  }

  &.edit {
    color: md-brown-500

    &:hover {
      color: md-brown-700
    }
  }

  &.preview {
    color: c-accent

    &:hover {
      color: c-accent
    }
  }

  &.receipt {
    color: md-blue-grey-600

    &:hover {
      color: md-blue-grey-700
    }
  }

  &.disable {
    color: md-grey-400
    cursor: not-allowed

    &:hover {
      color: md-grey-400
      cursor: not-allowed
    }
  }
}


.small-list {
  display: none
}

/*.small-list {
    display: flex
    justify-content: space-around
    flex-wrap: wrap

    .item {
        background: #fff;
        width: 49%;
        margin-bottom: 1%;
        padding: 1%;
    }
}*/

.small-screen {

  .big-list {
    display: none;
  }

  .small-list {
    display: flex
    justify-content: space-around
    flex-wrap: wrap

    .item {
      background: #fff;
      width: 100%;
      padding: 1% 3%;
      margin-bottom: 1%;
      position relative

      .action-selector-btn {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 30px;
        height: 30px;
        background: #bbc2c3;
        /* border: 1px solid #b9b9b9; */
        line-height: 30px;
        text-align: center;
        border-radius: 3px;
        font-size: 18px;
        color: #fff;
        cursor: pointer
        transition: all 0.3s

        &:hover {
          background: c-accent
        }

        .action-menu {
          position absolute
          z-index 9999
          width: 250px
          background: #fff
          padding: 10px;
          right: 30px
          top: 0

          .menu-item {
            text-align: left;
            color: #464646;
            /* border-bottom: 1px solid #777; */
            line-height: 10px;
            vertical-align: text-bottom;
            padding: 15px 10px;
            background: #dff6e0;
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 2px;

            &:last-child {
              border-bottom: none
            }

            &:hover {
              background: c-accent
              color: #fff
            }

            &.disable {
              opacity: 0.6
              background: #e6e6e6;
              color: #464646;
              cursor: not-allowed
            }

            .mdi {
              font-size: 24px;
              vertical-align: middle;
              margin-right: 5px;
            }
          }
        }

      }
    }
  }
}


.darkmode {

  .receipt-btn {
    &:hover {
      background: c-accent-dark
    }
    &.preview {
      color: c-accent-dark

      &:hover {
        color: c-accent-dark
      }
    }
  }



  .small-screen {
    .small-list {
      .item {
        background: c-dark-bg;
        border: 1px solid c-dark-bg !important

        .text-dark {
          color: c-body-font-dark !important
        }

        .action-selector-btn {
          background: c-accent-dark;
          color: #fff;
        }
      }
    }
  }
}

/* @media (max-width: 500px) {

 }*/


</style>
